


import EditIcon from '@mui/icons-material/Edit';
import { Box, LinearProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { BsFacebook, BsInstagram, BsYoutube } from "react-icons/bs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '../../App.css';
import InfluencerHeader from "./InfluencerHeader";
import Navbar from "./Navbar";

const InfluencerProfile = () => {
  const influencerId = localStorage.getItem("influencerID");
  const [userdata, setuserdata] = useState({});
  const [progress, setProgress] = useState(0);
  const [isSmallScreen, setIsSmallScreen] = useState(false);



useEffect(() => {
  const fetchTokenAndUpdateProfile = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (!code || !influencerId) return;

    try {
      const response = await fetch("https://server-side-influencer.onrender.com/influencer/get-instagram-token-and-update", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code, userId: influencerId }),
      });

      const data = await response.json();

      if (response.ok && data.access_token) {
        // Save the token in DBssss
        const saveRes = await fetch("https://server-side-influencer.onrender.com/influencer/save-token", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_id: influencerId,
            access_token: data.access_token,
          }),
        });

        if (saveRes.ok) {
          console.log("✅ Access token saved successfully");
        } else {
          console.error("❌ Failed to save access token");
        }

        toast.success("Influencer profile connected successfully!");
        fetchProfileData();
      } else {
        toast.error(data.message || "Failed to update influencer profile.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while connecting your Instagram account.");
    }
  };

  fetchTokenAndUpdateProfile();
}, [influencerId]);

const fetchProfileData = async () => {
  try {
    const res = await fetch(`https://server-side-influencer.onrender.com/influencer/getInfluencer/${influencerId}`);
    const data = await res.json();
    setuserdata(data.data);

    const progressRes = await fetch(`https://server-side-influencer.onrender.com/influencer/getInfluencerproggress/${influencerId}`);
    const progressData = await progressRes.json();
    if (progressData.success) setProgress(parseFloat(progressData.data.profileProgress));
  } catch (error) {
    console.error(error);
  }
};


  // 3. LOAD PROFILE DATA + PROGssss
  useEffect(() => {
    if (!influencerId) return;

    fetch(`https://server-side-influencer.onrender.com/influencer/getInfluencer/${influencerId}`)
      .then(res => res.json())
      .then(data => setuserdata(data.data))
      .catch(err => console.error("Error fetching influencer data:", err));

    fetch(`https://server-side-influencer.onrender.com/influencer/getInfluencerproggress/${influencerId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setProgress(parseFloat(data.data.profileProgress));
      })
      .catch(err => console.error("Error fetching progress:", err));
  }, [influencerId]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 720);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getProgressColor = (value) => {
    if (value < 60) return "red";
    if (value < 70) return "orange";
    return "green";
  };

  return (
    <div className="flex flex-col h-screen page-scroll">
      <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
        <InfluencerHeader page="profile" />
      </div>

      <div className="flex flex-1 pt-20">
        <div className="text-white fixed top-0 left-0 bottom-0 z-50">
          <Navbar />
        </div>

        <div className="w-full">
          {/* Header Banner */}
          <div className="relative h-96 w-full flex justify-center items-center">
            <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${userdata.profilepicinfluet2 || "https://i.postimg.cc/QM0NNSx2/dummyd.png"})` }}></div>
            <div className="absolute inset-0 bg-black bg-opacity-30" />
            <div className="absolute bottom-[-50px] flex flex-col items-center">
              <img className="w-28 h-28 rounded-full border-4 border-white object-cover shadow-lg"
                   src={userdata.profilepicinfluet || "https://res.cloudinary.com/dwy9jfjpq/image/upload/v1739715011/manager_profile_pics/xru8bht53ml5f5rvui9y.jpg"}
                   alt="Profile"
              />
              <a href="/InfluencerProfileEdit" className="absolute bottom-0 right-0 bg-white p-1 rounded-full shadow-md">
                <EditIcon className="text-gray-600" />
              </a>
            </div>
          </div>

          {/* Progress Section */}
          <div className="px-8 py-4 bg-white shadow-lg text-center w-3/4 mx-auto mt-20 mb-16">
            <strong style={{ color: "black" }} className="text-sm md:text-base">
              {progress >= 70 ? "Your profile is progressing well!" : "Please complete your profile to impress brands."}
            </strong>
            <Box sx={{ width: '60%' }} className="mx-auto relative mt-4">
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{
                  height: 5,
                  borderRadius: 10,
                  backgroundColor: '#e0e0e0',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: getProgressColor(progress),
                  },
                }}
              />
              <Typography
                variant="body2"
                className="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 font-bold"
              >
                {Math.round(progress)}%
              </Typography>
            </Box>
          </div>

          {/* Profile Info */}
          <div className="px-8 py-12 bg-white shadow-lg rounded-t-2xl text-left w-full md:w-[80%] mx-auto" style={{ marginLeft: isSmallScreen ? '6px' : '70px' }}>
            <div className="grid grid-cols-2 gap-4 max-w-lg mx-auto text-sm md:text-base">
              <p><strong>Full Name:</strong> {userdata.fullname || "John Doe"}</p>
              <p><strong>Mobile:</strong> {userdata.phone || "N/A"}</p>
              <p><strong>Email:</strong> {userdata.email || "N/A"}</p>
              <p><strong>Location:</strong> {userdata.city}, {userdata.state}, {userdata.country}</p>
              <p><strong>Category:</strong> {userdata.category || "N/A"}</p>
              <p><strong>Costing:</strong> {userdata.costingPerSegment || "N/A"}</p>
              <p><strong>Followers:</strong> {userdata.followers || "N/A"}</p>
              <p><strong>Username:</strong> {userdata.Username || "N/A"}</p>
              <p className="flex items-center gap-3">
                <strong>Socials:</strong>
                {userdata.facebookURL && <a href={userdata.facebookURL} target="_blank" rel="noreferrer"><BsFacebook size={20} color="#3b5998" /></a>}
                {userdata.youtubeLink && <a href={userdata.youtubeLink} target="_blank" rel="noreferrer"><BsYoutube size={20} color="#FF0000" /></a>}
                {userdata.instagramURL && <a href={userdata.instagramURL} target="_blank" rel="noreferrer"><BsInstagram size={20} color="#C13584" /></a>}
              </p>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default InfluencerProfile;
